import { useState, useEffect } from 'react'

interface TimeRemaining {
    hours: number
    minutes: number
    seconds: number
    hasFinished: boolean
}

function getTimeRemaining(target: Date): TimeRemaining {
    const now = Date.now()
    const difference = target.getTime() - now

    if (difference <= 0) {
        return { hours: 0, minutes: 0, seconds: 0, hasFinished: true }
    }

    const hours = Math.floor(difference / (1000 * 60 * 60))
    const minutes = Math.floor((difference / (1000 * 60)) % 60)
    const seconds = Math.floor((difference / 1000) % 60)

    return { hours, minutes, seconds, hasFinished: false }
}

export function useCountdownTimer(targetDate: Date) {
    const [timeRemaining, setTimeRemaining] = useState<TimeRemaining>(() =>
        getTimeRemaining(targetDate),
    )

    useEffect(() => {
        const interval = setInterval(() => {
            const newTime = getTimeRemaining(targetDate)
            setTimeRemaining(newTime)
            if (newTime.hasFinished) {
                clearInterval(interval)
            }
        }, 1000)

        return () => clearInterval(interval)
    }, [targetDate])

    if (
        timeRemaining.hasFinished ||
        (timeRemaining.hours <= 0 && timeRemaining.minutes <= 0)
    ) {
        return undefined
    }

    const hr = timeRemaining.hours > 0 ? `${timeRemaining.hours}hrs` : ''
    const min = timeRemaining.minutes > 0 ? `${timeRemaining.minutes}mins` : ''

    return `${hr} ${min}`.trim()
}
